import InteractiveResumeLayoutPage from "@/pages/InteractiveResumeLayoutPage";

function App() {
  return <InteractiveResumeLayoutPage />;
}

export default App;

